export default __webpack_public_path__ + "images/signupArt.c6da1693c0be32e301a8f08d9644050e.svg";